<template>
  <div class="gift-vouchers-payment bg-white has-shadow w-100 p-5">
    <div v-if="!hasNonMonetaryVoucher" class="row justify-content-center">
      <div class="col-24">
        <h3>Got gift vouchers?</h3>
        <p>Enter your voucher reference number below and we'll subtract the total from your bill</p>
        <div class="form-group row flex-row g-0">
          <div class="col-xl-16 mb-3 mb-xl-0">
            <input
              type="text"
              class="form-control"
              v-model="code"
              placeholder="Enter reference number"
            />
          </div>
          <button
            class="btn btn--gold col-12 col-xl-8"
            v-on:click="onCheckCode()"
            type="button"
          >
            Redeem
          </button>
        </div>
      </div>
    </div>

    <div v-else class="row justify-content-center">
      <div class="col-24">
        <h3>Gift vouchers</h3>
      </div>
    </div>

    <div
      class="applied-codes mt-2 p-3"
      v-if="booking.monetaryVouchers != null && booking.monetaryVouchers.length"
    >
      <div class="row">
        <div class="col-24">
          <h4 class="title">Applied Vouchers</h4>
          <ul class="m-0">
            <li v-for="appliedVoucher in booking.monetaryVouchers" class="mb-1">
              <div class="d-flex flex-column">
                <span> - {{ appliedVoucher.voucher.voucherName }} </span>

                <span class="mt-1">
                  &nbsp; The value of your voucher is £{{
                    appliedVoucher.voucher.unitPrice.amount
                  }}
                </span>
              </div>

              <button
                v-if="appliedVoucher.content.IsMonetary"
                type="button"
                class="remove"
                v-on:click="onRemoveVoucher(appliedVoucher)"
              >
                Remove
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div
      class="applied-codes applied-codes--invalid mt-2 p-3"
      v-if="invalidVouchers.length"
    >
      <div class="row">
        <div class="col-24">
          <h4 class="title">Invalid Vouchers</h4>
          <ul class="m-0">
            <li v-for="invalidVoucher in invalidVouchers">
              {{ invalidVoucher.voucher.voucher.voucherName }}
              <span v-if="invalidVoucher.reason"
                ><strong>{{ invalidVoucher.reason }}</strong></span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from "../store/index";
import giftVoucher from "@/shared/api/giftVoucher";

export default {
  name: "GiftVouchersPayment",
  data() {
    return {
      invalidVouchers: [],
      code: null,
    };
  },

  computed: {
    session() {
      return store.getters.session;
    },
    search() {
      return store.getters.search;
    },
    booking() {
      return store.getters.booking;
    },
    voucherCodes() {
      if (this.booking != null && this.booking.monetaryVouchers != null) {
        return this.booking.monetaryVouchers.map((item) =>
            item.voucher.certificateReferenceNumber.toString()
        );
      }
      return [];
    },
    hasNonMonetaryVoucher() {
      if (this.booking != null && this.booking.monetaryVouchers != null) {
        let mvs = this.booking.monetaryVouchers.filter(
          (item) => item.content.Category == 0
        );

        return mvs.length;
      }

      return false;
    },
  },
  methods: {
    onRemoveVoucher(voucher) {
      store.dispatch("removeVoucher", voucher);
    },

    onCheckCode() {
      let o = this;

      if (
        this.code != null &&
        this.code.length &&
        !this.voucherCodes.includes(this.code)
      ) {
        console.log("checkStatus", this.code, this.booking.arrivalDate);
        giftVoucher.checkStatus(
          this.code,
          this.booking.arrivalDate,
            function (t) {
                console.log("voucher", t);

            if (t.isAvailableOnline && t.canBeUsed && t.content.Category == 1) {
              store.dispatch("attachVoucher", t).then(() => {
                store.dispatch("stageBooking");
              });
            } else {
              if (t.isRedeemed) {
                o.invalidVouchers.push({ voucher: t, reason: "Already used" });
              } else if (t.isOutsidePeriod) {
                o.invalidVouchers.push({
                  voucher: t,
                  reason: "Voucher invalid for booking date",
                });
              } else if (t.isBooked) {
                o.invalidVouchers.push({ voucher: t, reason: "Already used" });
              } else if (!t.isAvailableOnline) {
                o.invalidVouchers.push({
                  voucher: t,
                  reason: "Cannot be used online",
                });
              } else if (t.content.Category != 0 && t.content.Category != 1) {
                o.invalidVouchers.push({
                  voucher: t,
                  reason: "Invalid category",
                });
              } else {
                o.invalidVouchers.push({ voucher: t, reason: "Unknown" });
              }
            }
            o.code = null;
          },
          function (t) {
            o.invalidVouchers.push({
                voucher: { voucher: { certificateReferenceNumber: o.voucherCode } },
              reason: "Cannot be found",
            });

            o.voucherCode = null;
            o.isCheckingCode = false;
          }
        );
      }
    },
  },
};
</script>

<style scoped>
.btn-remove {
  font-weight: bold;
  border: none;
  background: none;
  display: inline-block;
}

.applied-codes {
  background-color: rgba(52, 127, 52, 0.15);
  padding-left: 55px !important;
  background-size: 26px 26px;
  background-image: url("@/assets/img/website/tick.svg");
  background-repeat: no-repeat;
  background-position: 16px 16px;
}

.applied-codes ul {
  padding: 0;
}

.applied-codes ul li {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.applied-codes ul li::marker {
  color: black;
}

.applied-codes ul li .remove {
  border: none;
  background: transparent;
  cursor: pointer;
  text-indent: -9999px;
  background-size: 15px 15px;
  background-image: url("@/assets/img/booking/cross.svg");
  background-repeat: no-repeat;
  background-position: center center;
  height: 15px;
  width: 15px;
}

.applied-codes--invalid {
  background-image: url("@/assets/img/booking/exclamation.svg");
  background-color: rgba(161, 143, 91, 0.2);
}

.applied-codes .title {
  font-weight: bold;
  font-size: 16px;
  font-family: Montserrat;
}
</style>
